import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

const propTypes = {
    phones: PropTypes.array,
    sponsors: PropTypes.array,
};

const defaultProps = {
    phones: [
        {
            url: '#',
            name: 'Kids help phone',
            phone: '1-800-668-6868',
            description: 'Speak to a counselor. Find resources near you. 24/7, bilingual',
        },
        {
            url: '#',
            name: 'Avant de craquer',
            phone: '1-855-272-7837',
            description: 'Network of Quebec resources for people living with a mentally ill person',
        },
        {
            url: '#',
            name: 'First Nations & Inuit Help Line',
            phone: '1-855-242-3310',
            description: 'Call if you’re experiencing emotional distress and want to talk. 24/7',
        },
    ],

    sponsors: [
        {
            url: 'http://www.catbirdproductions.ca/',
            icon: 'catbird-film',
        },
        {
            url: 'http://telusfund.ca/',
            icon: 'telus-fund',
        },
        {
            url: 'http://www.cbc.ca/',
            icon: 'cbc',
        },
        {
            url: 'http://post-moderne.com/',
            icon: 'postmoderne',
        },
        {
            url: 'http://www.sodec.gouv.qc.ca/domaines-dintervention/cinema-et-television/',
            icon: 'taxcredit-quebec',
        },
        {
            url: 'http://canada.pch.gc.ca/eng/1455734346596',
            icon: 'taxcredit-canada',
        },
        {
            url: 'http://www.postimage.com',
            icon: 'postimage',
        },
    ],
};

class Footer extends Component {

    constructor(props) {
        super(props);
        this.renderPhone = this.renderPhone.bind(this);
        this.renderSponsor = this.renderSponsor.bind(this);

        this.onEmailChange = this.onEmailChange.bind(this);
        this.onEmailFocus = this.onEmailFocus.bind(this);

        this.state = {
            email: '',
            focused: false,
        };
    }

    onEmailChange(e) {
        this.setState({
            email: e.target.value,
        });
    }

    onEmailFocus() {
        this.setState({
            focused: true,
        });
    }

    // eslint-disable-next-line class-methods-use-this
    renderSponsor(item) {
        const className = classNames({
            sponsor: true,
            [item.icon]: true,
        });
        return (
            <a key={item.icon} href={item.url} className={className} />
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderPhone(item) {
        return (
            <div key={item.phone} className="line">
                <ul>
                    <li><a href={item.url} className="subtitle">{item.name}</a></li>
                    <li><a href={`tel:${item.phone}`} className="title">{item.phone}</a></li>
                    <li className="text small medium">{item.description}</li>
                </ul>
            </div>
        );
    }

    renderSubscribeForm() {
        const { email } = this.state;

        const formClassName = classNames({
            focused: this.state.focused,
            validate: true,
        });
        const placeholder = this.state.focused ? 'Type your email address' : 'Subscribe to our mailing list';

        // From our friends at MailChimp...
        return (
            <form action="//catbirdproductions.us6.list-manage.com/subscribe/post?u=a0eb0358d7&amp;id=239300bfe8" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className={formClassName} target="_blank" noValidate>
                <div id="mc_embed_signup_scroll">
                    <div className="mc-field-group">
                        <input type="email" value={email} onChange={this.onEmailChange} onFocus={this.onEmailFocus} name="EMAIL" className="required email" id="mce-EMAIL" placeholder={placeholder} />
                        <input type="hidden" value="html" name="EMAILTYPE" id="mce-EMAILTYPE-0" />
                    </div>
                    <div id="mce-responses" className="clear">
                        <div className="response" id="mce-error-response" style={{ display: 'none' }} />
                        <div className="response" id="mce-success-response" style={{ display: 'none' }} />
                    </div>
                    <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                        <input type="text" name="b_a0eb0358d7_239300bfe8" tabIndex="-1" value="" />
                    </div>
                    <input type="submit" value="Send" name="subscribe" id="mc-embedded-subscribe" className="btn btn-submit button" />
                </div>
            </form>
        );
    }

    render() {
        const { phones, sponsors } = this.props;

        return (
            <footer className="footer">
                <div className="phone-lines">
                    { phones.map(this.renderPhone) }
                    <div className="clearfix" />
                </div>
                <hr />
                <div className="social">
                    <span className="contact">
                        <a href="mailto:iamstillyourchild@catbirdproductions.ca" className="contact-us">Contact us</a>
                        <div className="subscribe-form medium">{ this.renderSubscribeForm() }</div>
                        <div className="copyright">@ 2017 <a href="http://www.catbirdproductions.ca/">Catbird Productions</a></div>
                    </span>
                    <span className="fright">
                        <a href="http://fb.me/IamStillYourChild" target="_blank" rel="noopener noreferrer"><div className="icon facebook" /></a>
                        <a href="http://twitter.com/stillyourchild" target="_blank" rel="noopener noreferrer"><div className="icon twitter" /></a>
                        <a href="https://www.youtube.com/channel/UCR2qZCAEvRnLSYkVU9FnFtQ" target="_blank" rel="noopener noreferrer"><div className="icon youtube" /></a>
                        <a href="http://instagram.com/iamstillyourchild" target="_blank" rel="noopener noreferrer"><div className="icon instagram" /></a>
                        <div className="clearfix" />
                    </span>
                </div>
                <div className="sponsors">
                    { sponsors.map(this.renderSponsor) }
                </div>
            </footer>
        );
    }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

const FooterContainer = connect(state => ({
    test: state.test,
    router: state.router,
}))(Footer);

export default FooterContainer;



// WEBPACK FOOTER //
// ./components/partials/Footer.jsx